/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_Bo as Bo,
  rec_H$ as H$,
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
  rec_Vo as Vo,
} from "../../runtime/index.jsx";
export function Componente_XDolar_88_36(e) {
  let t = (0, ReactCompiler.c)(8),
    { tipo: n, onClick: r } = e,
    i;
  t[0] === n ? (i = t[1]) : ((i = H$(n)), (t[0] = n), (t[1] = i));
  let a;
  t[2] === i
    ? (a = t[3])
    : ((a = (
        <span
          className={`animar-flotar text-4xl`}
          aria-hidden={`true`}
          children={i}
        />
      )),
      (t[2] = i),
      (t[3] = a));
  let o;
  return (
    t[4] !== r || t[5] !== a || t[6] !== n.nombre
      ? ((o = (
          <button
            type={`button`}
            onClick={r}
            className={`${Bo} ${Vo} flex min-h-28 flex-col items-center justify-center gap-2 !p-3 text-center text-sm font-semibold text-(--text-h) transition duration-200 hover:-translate-y-0.5 hover:border-(--accent-border) hover:shadow-md active:scale-[0.94]`}
            children={[a, n.nombre]}
          />
        )),
        (t[4] = r),
        (t[5] = a),
        (t[6] = n.nombre),
        (t[7] = o))
      : (o = t[7]),
    o
  );
}
